// client/src/components/FeaturedProductCard.js
import React from 'react';
import { useQuote } from '../context/QuoteContext';

const FeaturedProductCard = ({ product }) => {
  const { openModal } = useQuote();

  const handleCardClick = () => {
    // When the card is clicked, open the quote modal with this product's data
    openModal(product);
  };

  return (
    <div className="featured-product-card" onClick={handleCardClick}>
      <div className="featured-product-image">
        <img src={product.imageUrl || '/images/placeholder.png'} alt={product.name} />
      </div>
      {/* This overlay is hidden by default and appears on hover */}
      <div className="featured-product-overlay">
        <h3>{product.name}</h3>
      </div>
    </div>
  );
};

export default FeaturedProductCard;